import styled from 'styled-components';
import { desktopBodyLargeListCss, mobileBodyStandardListCss } from '$base-styles/typography';
import { media } from '$util/theme';

export const Styled = styled.li`
  display: flex;
  align-items: flex-start;

  p {
    margin-bottom: 0;
    ${mobileBodyStandardListCss}

    ${media.up('sm')} {
      ${desktopBodyLargeListCss}
    }
  }

  .tick {
    margin-right: 14px;
  }

  .bullet {
    margin-right: 7px;
  }
`;
